import React, { useState, forwardRef, useImperativeHandle } from 'react';
import BlockUi from 'react-block-ui';
import env from '../../environment';

const ModalWhatsappConfirm = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setShow(true),
    close: () => setShow(false),
    setBlocking,
  }));

  if (!show) return null;

  const tieneTelefono = !!props.telefono;

  const closeHandler = () => {
    if (!blocking) setShow(false);
  };

  const validateHandler = () => {
    if (!tieneTelefono) return;
    props.onConfirm();
  };

  const textoStyle = {
    color: '#333',
    marginBottom: '20px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1060,
      }}
      onClick={closeHandler}>
      <style>{`
        .modal-whatsapp-confirm button {
          font-family: 'Lato' !important;
          font-style: normal !important;
          font-weight: 400 !important;
          font-size: 14px !important;
          line-height: 18px !important;
        }
      `}</style>
      <BlockUi
        message=""
        blocking={blocking}
        renderChildren={false}
        className="modal-whatsapp-confirm"
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '10px',
          minWidth: '350px',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
        onClick={e => e.stopPropagation()}>
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h4 style={{ margin: 0, marginRight: '10px', color: '#333' }}>Enviar ficha por WhatsApp</h4>
          <i className="fab fa-whatsapp" style={{ fontSize: 24, color: env.colors.primary_500 }}></i>
        </div>

        <p style={textoStyle}>
          {tieneTelefono ? (
            <>
              {'Se enviarán las fichas y reportes '}
              {props.nombreProductor && (
                <>
                  {'de '}
                  <strong>{props.nombreProductor}</strong>{' '}
                </>
              )}
              {'por WhatsApp al número registrado '}
              <strong>{props.telefono}</strong>
              {'. ¿Desea continuar?'}
            </>
          ) : (
            `No hay un número de WhatsApp registrado: ${props.nombreProductor ? 'para ' + props.nombreProductor : 'para este productor'}.`
          )}
        </p>

        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', alignItems: 'center' }}>
          <button
            type="button"
            onClick={closeHandler}
            style={{
              padding: '10px 24px',
              backgroundColor: '#f8f9fa',
              color: '#666',
              border: '1px solid #ddd',
              borderRadius: '5px',
              cursor: 'pointer',
              boxSizing: 'border-box',
              fontSize: '14px',
            }}>
            Cancelar
          </button>
          <button
            type="button"
            onClick={validateHandler}
            disabled={!tieneTelefono}
            style={{
              padding: '10px 24px',
              backgroundColor: tieneTelefono ? env.colors.primary_500 : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: tieneTelefono ? 'pointer' : 'not-allowed',
              boxSizing: 'border-box',
              transition: 'background-color 0.2s',
              fontSize: '14px',
            }}
            onMouseOver={e => tieneTelefono && (e.target.style.backgroundColor = env.colors.primary_300)}
            onMouseOut={e => tieneTelefono && (e.target.style.backgroundColor = env.colors.primary_500)}>
            Sí, enviar
          </button>
        </div>
      </BlockUi>
    </div>
  );
});

ModalWhatsappConfirm.displayName = 'ModalWhatsappConfirm';

export default ModalWhatsappConfirm;
